import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';

import NavBar from './components/Navbar/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import Contact from './pages/Contact';
import Services from './pages/Services';
import Works from './pages/Works';
import OurTeam from './pages/OurTeam';
import './App.scss';

const App = () => {
  return (
    <div className="App">
      <HashRouter basename="/">
        <ScrollToTop />
        <NavBar />

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<Contact />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path="/works" element={<Works />} />
          <Route path="/team" element={<OurTeam />} />
        </Routes>
      </HashRouter>

      <Footer />
    </div>
  );
};

export default App;
